export default "/fonts/Acrom-Bold.woff?aa7b7c94a6ff765454fbed338e5d98e7";